import { render, staticRenderFns } from "./Page03Sub01.vue?vue&type=template&id=192b4db4&scoped=true&"
import script from "./Page03Sub01.vue?vue&type=script&lang=js&"
export * from "./Page03Sub01.vue?vue&type=script&lang=js&"
import style0 from "./Page03Sub01.vue?vue&type=style&index=0&id=192b4db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b4db4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QTooltip,QList,QItem,QItemSection,QIcon,QTable,QSelect,QInput,QBtn,QTr,QTh,QTd,Ripple} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QTooltip,QList,QItem,QItemSection,QIcon,QTable,QSelect,QInput,QBtn,QTr,QTh,QTd}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
